<template>
  <b-row>
    <div class="col-12 col-sm-9">
      <b-card class="mb-3" :header="'Form Filters for: ' + itemForm.name">
        <section v-if="itemForm.type == 'OrderedStorefrontItemsReport'">
            <OrderedStorefrontItemsReport-form :viewOnly="true" :reportFilters="itemForm.orderedItemsReportFilters"></OrderedStorefrontItemsReport-form>
          </section>
          <section v-if="itemForm.type == 'OrderedWarehouseItemsReport'">
            <OrderedWarehouseItemsReport-form :viewOnly="true" :reportFilters="itemForm.orderedItemsReportFilters">
            </OrderedWarehouseItemsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMargin' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReport-form :viewOnly="true" :reportFilters="itemForm.financeMarginReportFilters"></ReportFinanceMarginReport-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMarginSummary' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReportSummary-form :viewOnly="true" :reportFilters="itemForm.financeMarginReportFilters"></ReportFinanceMarginReportSummary-form>
          </section>
          <section v-else-if="itemForm.type == 'ReportItemsOnBackorder' && itemForm.requestFilters">
            <ReportItemsOnBackorder-form :viewOnly="true" :reportFilters="itemForm.requestFilters"></ReportItemsOnBackorder-form>
          </section>
          <section v-else-if="itemForm.type == 'FactoringFinanceInvoiceReport'">
            <FactoringFinanceInvoiceReport-form :viewOnly="true" :reportFilters="itemForm.factoringFinanceInvoiceFilters"></FactoringFinanceInvoiceReport-form>
          </section>
          <section v-else-if="itemForm.type == 'InventoryStatusItemsReport'">
            <InventoryStatusItemsReport-form :viewOnly="true" :reportFilters="itemForm.inventoryTotalReportFilters"></InventoryStatusItemsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontShippedCount'">
            <StorefrontShippedCount-form :viewOnly="true" :reportFilters="itemForm.shipmentCountReportFilters"></StorefrontShippedCount-form>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontReshipReportByMonth'">
            <StorefrontReshipReportByMonth-form :viewOnly="true" :reportFilters="itemForm.storefrontReshipReportByMonthFilters"></StorefrontReshipReportByMonth-form>
          </section>
          <section v-else-if="itemForm.type == 'WarehouseItemsInOutReport'">
            <WarehouseItemsInOutReport-form :viewOnly="true" :reportFilters="itemForm.warehouseItemsInOutReportFilters"></WarehouseItemsInOutReport-form>
          </section>
          <section v-else-if="itemForm.type == 'OrderFulfillmentsReport'">
            <OrderFulfillmentsReport-form :viewOnly="true" :reportFilters="itemForm.orderFulfillmentReportFilters"></OrderFulfillmentsReport-form>
          </section>
          <section v-else-if="itemForm.type == 'HistoricalInventoryReport'">
            <HistoricalInventoryReport-form :viewOnly="true" :reportFilters="itemForm.inventoryHistoricalReportFilters"></HistoricalInventoryReport-form>
          </section>
      </b-card>
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <section v-if="itemForm.type == 'OrderedStorefrontItemsReport'">
            <OrderedStorefrontItemsReport-view :items="itemForm.reportData.orderedItemsReport.items"></OrderedStorefrontItemsReport-view>
          </section>
          <section v-if="itemForm.type == 'OrderedWarehouseItemsReport'">
            <OrderedWarehouseItemsReport-view :items="itemForm.reportData.orderedItemsReport.items"></OrderedWarehouseItemsReport-view>
          </section>
          <!-- <section v-else-if="itemForm.type == 'InventoryStatusItemsReport'">
            <InventoryStatusItemsReport-view :reportFilters="itemForm.inventoryTotalReportFilters"></InventoryStatusItemsReport-view>
          </section> -->
          <section v-else-if="itemForm.type == 'FactoringFinanceInvoiceReport'">
            <FactoringFinanceInvoiceReport-view :items="itemForm.reportData.factoringFinanceInvoiceNewResponse.items"></FactoringFinanceInvoiceReport-view>
          </section>
          <section v-else-if="itemForm.type == 'ReportItemsOnBackorder'">
            <ReportItemsOnBackorder-view
              v-if="itemForm.reportResultJson && itemForm.reportResultJson.products"
              :items="itemForm.reportResultJson.products"
            ></ReportItemsOnBackorder-view>
            <b-alert show variant="warning" v-else>The report result could not be loaded.</b-alert>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontShippedCount'">
            <StorefrontShippedCount-view :items="itemForm.reportData.storefrontShippedCountReport"></StorefrontShippedCount-view>
          </section>
          <section v-else-if="itemForm.type == 'StorefrontReshipReportByMonth'">
            <StorefrontReshipReportByMonth-view :items="itemForm.reportData.storefrontReshipByMonthItems"></StorefrontReshipReportByMonth-view>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMargin' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReport-view :items="itemForm.reportData.reportFinanceMarginResponse.items"></ReportFinanceMarginReport-view>
          </section>
          <section v-else-if="itemForm.type == 'ReportFinanceMarginSummary' && has('pm.orders.view.financeMargin')">
            <ReportFinanceMarginReportSummary-view :items="itemForm.reportData.reportFinanceMarginResponse.summaryItems"></ReportFinanceMarginReportSummary-view>
          </section>
          <section v-else-if="itemForm.type == 'WarehouseItemsInOutReport'">
            <WarehouseItemsInOutReport-view :items="itemForm.reportData.warehouseItemsInOutReportResponse.items"></WarehouseItemsInOutReport-view>
          </section>

          <section v-else-if="itemForm.type == 'OrderFulfillmentsReport'">
            <OrderFulfillmentsReport-view :items="itemForm.reportData.ordersFulfillmentReportResponse.items"></OrderFulfillmentsReport-view>
          </section>

          <section v-else-if="itemForm.type == 'HistoricalInventoryReport'">
            <HistoricalInventoryReport-view :items="itemForm.reportData.inventoryHistoricalReportResponse.items"></HistoricalInventoryReport-view>
          </section>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <router-link
          v-if="itemForm.type != 'FactoringFinanceInvoiceReport'"
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Reports.GeneratedReports.Index', params: {type: itemForm.type} }"
        >
          <span>Back</span>
        </router-link>
        <router-link
          v-else-if="itemForm.factoringFinanceInvoiceFilters"
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-info"
          :to="{ name: 'Admin.Brands.Manage', params: {id: itemForm.factoringFinanceInvoiceFilters.brandId} }"
        >
          <span>Back</span>
        </router-link>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import OrderedStorefrontItemsReport from './viewPartials/OrderedStorefrontItemsReport'
import OrderedWarehouseItemsReport from './viewPartials/OrderedWarehouseItemsReport'
import OrderFulfillmentsReport from './viewPartials/OrderFulfillmentsReport'
import StorefrontShippedCount from './viewPartials/StorefrontShippedCount'
import StorefrontReshipReportByMonth from './viewPartials/StorefrontReshipReportByMonth'
import WarehouseItemsInOutReport from './viewPartials/WarehouseItemsInOutReport'
import ReportFinanceMarginReport from './viewPartials/ReportFinanceMarginReport'
import ReportFinanceMarginReportSummary from './viewPartials/ReportFinanceMarginReportSummary'
import FactoringFinanceInvoiceReport from './viewPartials/FactoringFinanceInvoiceReport'
import HistoricalInventoryReport from './viewPartials/HistoricalInventoryReport'
import ReportItemsOnBackorder from './viewPartials/ReportItemsOnBackorder'
import ReportItemsOnBackorderForm from './formPartials/ReportItemsOnBackorder'

import OrderedStorefrontItemsReportForm from './formPartials/OrderedStorefrontItemsReport'
import OrderedWarehouseItemsReportForm from './formPartials/OrderedWarehouseItemsReport'
import OrderFulfillmentsReportForm from './formPartials/OrderFulfillmentsReport'
import StorefrontShippedCountForm from './formPartials/StorefrontShippedCount'
import StorefrontReshipReportByMonthForm from './formPartials/StorefrontReshipReportByMonth'
import WarehouseItemsInOutReportForm from './formPartials/WarehouseItemsInOutReport'
import ReportFinanceMarginReportForm from './formPartials/ReportFinanceMarginReport'
import ReportFinanceMarginReportSummaryForm from './formPartials/ReportFinanceMarginReportSummary'
import FactoringFinanceInvoiceReportForm from './formPartials/FactoringFinanceInvoiceReport'
import InventoryStatusItemsReportForm from './formPartials/InventoryStatusItemsReport'
import HistoricalInventoryReportForm from './formPartials/HistoricalInventoryReport'

import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
const mixinCrud = crudMixinGen('generatedReports');
export default {
  mixins: [mixinCrud, myCommonDataMixin],
  components: {
    'FactoringFinanceInvoiceReport-form': FactoringFinanceInvoiceReportForm,
    'OrderedWarehouseItemsReport-form': OrderedWarehouseItemsReportForm,
    'OrderedStorefrontItemsReport-form': OrderedStorefrontItemsReportForm,
    'OrderFulfillmentsReport-form': OrderFulfillmentsReportForm,
    'WarehouseItemsInOutReport-form': WarehouseItemsInOutReportForm,
    'ReportFinanceMarginReport-form': ReportFinanceMarginReportForm,
    'ReportFinanceMarginReportSummary-form': ReportFinanceMarginReportSummaryForm,
    'StorefrontShippedCount-form': StorefrontShippedCountForm,
    'StorefrontReshipReportByMonth-form': StorefrontReshipReportByMonthForm,
    'InventoryStatusItemsReport-form': InventoryStatusItemsReportForm,
    'HistoricalInventoryReport-form': HistoricalInventoryReportForm,
    'ReportItemsOnBackorder-form': ReportItemsOnBackorderForm,
    'ReportItemsOnBackorder-view': ReportItemsOnBackorder,

    'FactoringFinanceInvoiceReport-view': FactoringFinanceInvoiceReport,
    'OrderedWarehouseItemsReport-view': OrderedWarehouseItemsReport,
    'OrderedStorefrontItemsReport-view': OrderedStorefrontItemsReport,
    'OrderFulfillmentsReport-view': OrderFulfillmentsReport,
    'WarehouseItemsInOutReport-view': WarehouseItemsInOutReport,
    'ReportFinanceMarginReport-view': ReportFinanceMarginReport,
    'ReportFinanceMarginReportSummary-view': ReportFinanceMarginReportSummary,
    'StorefrontShippedCount-view': StorefrontShippedCount,
    'StorefrontReshipReportByMonth-view': StorefrontReshipReportByMonth,
    'HistoricalInventoryReport-view': HistoricalInventoryReport,
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: () => ({
    heading: 'Report Info',
  }),

  computed: {
    ...mapState('generatedReports', ['reportTypesList']),
    // reportTypesListFiltered: {
    //   get() {
    //     var reportTypes = this.reportTypesList;
    //     if(this.has('pm.orders.view.financeMargin')) {
    //       reportTypes = reportTypes.push({ value: 'ReportFinanceMargin', text: 'Finance Margin Report' });
    //     }
    //     return reportTypes;
    //   },
    //   set() {

    //   }
    // }
  },

  mounted() {
    this.LoadItem(this.id);
  },

  methods: {
  }
};
</script>
